import { useFrame } from "@react-three/fiber";
import { useRef } from "react";

/**
 * Hide lower-priority labels that overlap a shown one (rects from the DOM, checked ~10×/s).
 * Labels marked `data-edge-on` (their dimension is seen end-on) or `data-off` (switched off,
 * fading out) are skipped: they neither hide nor get hidden.
 */
export function useLabelCollisions(refs: React.MutableRefObject<(HTMLElement | null)[]> | (() => (HTMLElement | null)[]), count: number) {
  const last = useRef(0);
  useFrame(({ clock }) => {
    const t = clock.elapsedTime;
    if (t - last.current < 0.1) return;
    last.current = t;
    const shown: DOMRect[] = [];
    const els = typeof refs === "function" ? refs() : refs.current;
    for (let i = 0; i < count; i++) {
      const el = els[i];
      if (!el || el.hasAttribute("data-edge-on") || el.hasAttribute("data-off")) continue;
      const r = el.getBoundingClientRect();
      const pad = 4;
      const hit = shown.some((o) => r.left < o.right + pad && r.right > o.left - pad && r.top < o.bottom + pad && r.bottom > o.top - pad);
      if (hit !== el.hasAttribute("data-hidden")) el.toggleAttribute("data-hidden", hit);
      el.style.visibility = hit ? "hidden" : "";
      if (!hit) shown.push(r);
    }
  });
}
